<template>
  <div class="container page">
    <van-nav-bar :title="this.vod_name" class="nav-bar">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()" />
      </template>
    </van-nav-bar>
    <div class="right">
      <van-pull-refresh v-model="isLoading" border="false" class="list-wrapper" @refresh="onRefresh">
        <div class="lady-list">
          <LadyCard :info="v" v-for="v in datalist" :key="v.id" />
          <div class="hot-recommend-more">{{ $t('没有更多了') }}</div>
        </div>

        <!--<van-grid :column-num="2" :gutter="10">-->
        <!--  <van-grid-item v-for="(v, k) in datalist" :key="k" @click="profile(v.id)">-->
        <!--    <van-image :src="v.img_url" class="game_item_img">-->
        <!--      <template v-slot:loading>-->
        <!--        <van-loading type="circular"/>-->
        <!--      </template>-->
        <!--    </van-image>-->
        <!--    <span class="rig-name">{{ v.xuanfei_name }}</span>-->
        <!--  </van-grid-item>-->
        <!--</van-grid>-->
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import LadyCard from '@/components/LadyCard.vue'

export default {
  components: { LadyCard },
  data() {
    return {
      vod_name: '北京',
      isLoading: false,
      datalist: []
    }
  },
  methods: {
    back() {
      this.$router.push({ path: 'Choose' })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('刷新成功') + '！')
        this.getxuanfeilist()
        this.isLoading = false
      }, 500)
    },
    profile(id) {
      this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id })
    },
    getxuanfeilist() {
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: this.$route.query.id }
      }).then((res) => {
        this.datalist = res.data
      })
    }
  },
  created() {
    this.vod_name = this.$route.query.name
    this.getxuanfeilist()
  }
}
</script>

<style scoped>
.container {
  background-color: #fff;
}
.right {
  background-color: #fff;
}

::v-deep .van-grid-item__content--center {
  border-radius: 15px;
  padding: 0;
  height: auto;
}

::v-deep .van-image__img {
  border-radius: 10px;
  padding: 15px;
}

.rig-name {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin-top: 10px;
  background-color: #f7f7f7;
  border-radius: 0 0 15px 15px;
  font-size: 15px;
  padding-left: 10px;
}

.lady-list {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}
</style>
